import {Box, Button, Grid, FormControlLabel, FormControl, Checkbox, MenuItem, Select} from '@mui/material';
import React, {Fragment, useEffect} from 'react';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import {action} from 'mobx';
import {DateTime} from 'luxon';
import {getShortSpecName, dayNamesShort} from './Trans.js';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import BottomBar from './BottomBar.js';
import ObsAppBar from './AppBar.js';
import {COMM_OK} from './WsR2.js';

const CT_IN	= 0;
const CT_START	= 1;
const CT_END	= 2;

const cts = [
	"calendar.in",
	"calendar.starting",
	"calendar.ending"
];

const MT_MIGR	= 1;
const MT_WAND	= 2;

const mts = [
	"calendar.all",
	"calendar.migration",
	"calendar.wandering"
];

export const CalNavi = ((props) => {
	const {onPrev, onNext} = props;

	if (window.location.pathname !== '/calendar')
		return null;

	if (!onPrev || !onNext)
		return null;

	return (
		<Grid container direction={'row'} spacing={0} style={{flexGrow: 1}} justifyContent='center'>
			<Grid>
				<Button variant="contained" color="primary" size="small" style={{width:64, margin: 8}} onClick={onPrev}>&lt;&lt;</Button>
				<Button variant="contained" color="primary" size="small" style={{width:64, margin: 8}} onClick={onNext}>&gt;&gt;</Button>
			</Grid>
		</Grid>
	);
});

const Calendar = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const dt = gStorage.calendar.dt;

	useEffect(() => {
		if (!dt)
			gStorage.calendar.setDt(DateTime.now());

		if (!gStorage.calendar.dates) 
			loadDates();

		// eslint-disable-next-line
	}, []);

	const getheader = () => t('menu.calendar');

	function calendarRxWs(status, msg) {
		if (status !== COMM_OK) {
			console.error('calendarRxWs: error ', status);
			return -1;
		}

		if (msg.cmd === 'tax_dates') {
			if (msg.op === 'dates') {
				if (msg.result === 'OK') {
// 					console.log('calendarRxWs', msg);
					gStorage.calendar.setDates(msg.data.dates);
				} else {
					console.error('calendarRxWs:', msg.cmd, msg.op, 'failed!');
				}
			} else {
				console.error('calendarRxWs: unknown operation', msg.cmd, msg.op, msg.result);
			}
		} else {
			console.error('calendarRxWs: invalid command', msg.cmd, msg.op);
		}
	}

	function loadDates() {
// 		const dt = new Date();

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'tax_dates',
			op: 'dates',
			data: {
// 				jam: gStorage.calendar.jam_time,
// 				date: {
// 					dom: dt.day,
// 					m: dt.month,
// 				},
// 				pre: gStorage.calendar.pre_time,
			}
		};

// 		console.log('loadDates', msg);
		gStorage.conn.ws.send(msg, calendarRxWs);
	}

	function calendarSpecName(spec_id) {
		const spec = gStorage.lists.speclist.list.find(s => s.id === spec_id);
		return getShortSpecName(spec, gStorage.conn.user);
	}

	function migrTypeBgColor(migr_type) {
		if (migr_type === 'spring_migration') {
			return '#AED581';
		} else if (migr_type === 'autumn_migration') {
			return '#FFAB91';
		}

		return '#E0E0E0';
	}

	if (!gStorage.calendar.dates)
		return null;
/*	
	let labels = [];
	gStorage.calendar.dates.forEach((d) => {
		const n = calendarSpecName(d.spec_id);

		d.dates.forEach((dd, i) => {
			if (['spring_migration', 'autumn_migration'].includes(dd.type)) {
// 				if (i > 0) {
// 					console.log('i', i, n);
// 				}

				labels.push(n);
			}
		});
	});

	let data = [], bg = [], data2 = [], bg2 = [];
	const dt = DateTime.now();
	
	gStorage.calendar.dates.forEach((d, ind) => {
// 		console.log('d', d.dates);

		d.dates.forEach((dd) => {
			if (['spring_migration', 'autumn_migration'].includes(dd.type)) {
				let dts = DateTime.local(dt.year, dd.start.m, dd.start.dom);
				let dte = DateTime.local(dt.year, dd.end.m, dd.end.dom);

				// Change of the year in between?
				if (dts >= dte) {
					if (dt <= dte) {
						dts.minus({years: 1});
					} else if (dt >= dts) {
						dte.plus({years: 1});
					}
				}

				dts = dts.startOf('day');
				dte = dte.endOf('day');

// 				console.log('dates', dts.toISO(), dte.toISO());

				data.push([dts.toISO(), dte.toISO()]);
				bg.push(migrTypeBgColor(dd.type));

				if (dd.jam_start.m) {
					dts = DateTime.local(dt.year, dd.jam_start.m, dd.jam_start.dom);
					dte = DateTime.local(dt.year, dd.jam_end.m, dd.jam_end.dom);

					// Change of the year in between?
					if (dts >= dte) {
						if (dt <= dte) {
							dts.minus({years: 1});
						} else if (dt >= dts) {
							dte.plus({years: 1});
						}
					}

					dts = dts.startOf('day');
					dte = dte.endOf('day');

					data2.push([dts.toISO(), dte.toISO()]);
				} else {
					data2.push(['', '']);
				}

				bg2.push(DarkenColor(migrTypeBgColor(dd.type), 25));
			}
		})
	});
				<Grid size={{xs: 12}} align={'center'} sx={{m: 2}}>
					<Bar 
						data={{
							labels: labels,
							datasets: [
								{
									label: t('calendar.jam'),
									data: data2,
									backgroundColor: bg2,
								}, {
									label: t('calendar.range'),
									data: data,
									backgroundColor: bg,
								}
							],
							borderWidth: 1
						}}
						options = {{
							indexAxis: 'y',
							responsive: true,
							scales: {
								x: {
									min: dt.minus({'days': 7}).toISO(),
									max: dt.plus({'months': 1}).toISO(),
									type: 'time',
									time: {
										unit: 'day'
									}
								},
								y: {
									beginAtZero: false,
									stacked: true,
								}
							},
						}}
					/>
				</Grid>
*/

// 	function calendarWanderingChange() {
// 		gStorage.calendar.setWandering(!gStorage.calendar.wandering);
// 	}

	function calendarJamTimeChange() {
		gStorage.calendar.setJamTime(gStorage.calendar.jam_time ? 0 : 1);
	}
	
	function mtChange(e) {
		gStorage.calendar.setMigrType(parseInt(e.target.value, 10));
	}

	function ctChange(e) {
		gStorage.calendar.setChangeType(parseInt(e.target.value, 10));
	}
	
	function prevWeek() {
// 		console.log('prevWeek');
		gStorage.calendar.setDt(dt.minus({'days':7}));
	}

	function nextWeek() {
// 		console.log('nextWeek');
		gStorage.calendar.setDt(dt.plus({'days':7}));
	}

	return (
		<Fragment>
			<ObsAppBar getheader={getheader}/>
			<Grid container direction="column" justifyContent="center" alignItems="center" spacing={0}>
				<Grid size={{xs: 12}} sx={{mt:1}} align={'center'}>
					<Select 
						size='small'
						value={gStorage.calendar.migr_type}
						onChange={mtChange}
					>
						{mts.map((mt, ind) => {
							return (<MenuItem key={ind} value={ind}>{t(mt)}</MenuItem>);
						})}
					</Select>
				</Grid>

				<Grid size={{xs: 12}} sx={{mt:1}} align={'center'}>
					<Select 
						size='small'
						value={gStorage.calendar.change_type}
						onChange={ctChange}
					>
						{cts.map((ct, ind) => {
							return (<MenuItem key={ind} value={ind}>{t(ct)}</MenuItem>);
						})}
					</Select>
				</Grid>

				<Grid size={{xs: 12}} align={'center'}>
					<FormControl>
						<FormControlLabel
							label={t('calendar.jam_time')}
							labelPlacement="start"
							checked={Boolean(gStorage.calendar.jam_time)}
							onChange={calendarJamTimeChange}
							disabled={!gStorage.conn.online}
							control={<Checkbox color="primary" />}
							xs={{m: 8}}
						/>
					</FormControl>
				</Grid>

				<Grid align={'center'} sx={{m: 1, width: 300}}>
					<Box sx={{fontWeight: 'bold', bm:2}}>{t(dayNamesShort[dt.weekday - 1]) + ' ' + dt.day + '.' + dt.month + '.' + dt.year + ' ' + t('calendar.week_short') + ' ' + dt.weekNumber}</Box>
				</Grid>

				{gStorage.calendar.dates.map((d, ind) => {
					return d.dates.map((dd, ind) => {
						let dts, dte;

						if (gStorage.calendar.migr_type === MT_MIGR) {
							if (!['spring_migration', 'autumn_migration'].includes(dd.type))
								return null;
						} else if (gStorage.calendar.migr_type === MT_WAND) {
							if (!['spring_wandering', 'autumn_wandering'].includes(dd.type))
								return null;
						}

						/* -------------------------- */

						if (gStorage.calendar.jam_time) {
							if (!dd.jam_start || !dd.jam_end)
								return null;

							dts = DateTime.local(dt.year, dd.jam_start.m, dd.jam_start.dom).startOf('day');
							dte = DateTime.local(dt.year, dd.jam_end.m, dd.jam_end.dom).endOf('day');
						} else {
							dts = DateTime.local(dt.year, dd.start.m, dd.start.dom).startOf('day');
							dte = DateTime.local(dt.year, dd.end.m, dd.end.dom).endOf('day');
						}

						if (dts >= dte) {
							if (dt <= dte) {
								dts = dts.minus({years: 1});
							} else if (dt >= dts) {
								dte = dte.plus({years: 1});
							}
						}

						if (gStorage.calendar.change_type === CT_IN) {
							if (dts > dt || dte < dt)
								return null;
						} else if (gStorage.calendar.change_type === CT_START) {
// 							console.log('ct_start', dts.day + '.' + dts.month, dt.day + '.' + dt.month);

							if (dts < dt || dts > dt.plus({'days': gStorage.calendar.pre_time}))
								return null;
						} else if (gStorage.calendar.change_type === CT_END) {
// 							console.log('ct_end', dte.day + '.' + dte.month, dt.day + '.' + dt.month);
							if (dte < dt || dte > dt.plus({'days': gStorage.calendar.pre_time}))
								return null;
						} else {
							console.error('Invalid change_type', gStorage.calendar.change_type);
							return null;
						}

						/* -------------------------- */

						const jam_str = dd.jam_start && dd.jam_start.m ? ' ' + dd.jam_start.dom + '.' + dd.jam_start.m + '.-' + dd.jam_end.dom + '.' + dd.jam_end.m + '. - ' : '';
						const bg = migrTypeBgColor(dd.type);

						return (
							<Grid align={'center'} style={{margin:2}} sx={{width: 300,  border: 1, borderRadius: 2, borderColor: '#c0c0c0', backgroundColor: bg}} key={ind}>
								<Box sx={{fontWeight: 'bold', mt: 1}}>{calendarSpecName(d.spec_id)}</Box>
								<Box>{t('taxons.' + dd.type)}</Box>
								<Box sx={{mb: 1}}>{dd.start.dom + '.' + dd.start.m + '.-' + jam_str + dd.end.dom + '.' + dd.end.m + '.'}</Box>
							</Grid>
						)
					})
				})}
			</Grid>
			<BottomBar 
				onPrev={action(() => prevWeek())}
				onNext={action(() => nextWeek())}
			/>
		</Fragment>
	);
});

export default Calendar;
